import React from 'react';
import styled from 'styled-components';
import { Well } from 'react-bootstrap';

let Local = {};

Local.Well = styled(Well)`
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;

  p {
    color: #666;
    font-size: 20px;
    font-weight: 700;
  }

  a {
    margin: 30px 10px;

  }
`;

const ZeroState = ({ children }) => (
  <Local.Well>
    {children}
  </Local.Well>
);

export default ZeroState;



// WEBPACK FOOTER //
// ./src/components/ui/ZeroState.js